/* eslint-disable no-console */
import jwt_decode from "jwt-decode";

import LOCAL_STORAGE from "@/constants/local-storage";

const LOG_KEY = "t2b_session_log";
const MAX_ENTRIES = 50;

interface IDecoded {
  exp?: number;
  iat?: number;
  nbf?: number;
}

export interface ISessionLogEntry {
  at: string;
  reason: string;
  path: string;
  hadAccessToken: boolean;
  hadRefreshToken: boolean;
  tokenRemaining: string | null;
  tokenLifetime: string | null;
  extra?: Record<string, unknown>;
}

const fmt = (seconds: number) => {
  if (seconds <= 0) return "EXPIRADO";
  const m = Math.round(seconds / 60);
  return m < 60 ? `${m} min` : `${(m / 60).toFixed(1)} h`;
};

export const readSessionLog = (): ISessionLogEntry[] => {
  try {
    return JSON.parse(localStorage.getItem(LOG_KEY) || "[]");
  } catch {
    return [];
  }
};

export const clearSessionLog = () => localStorage.removeItem(LOG_KEY);

export const logSessionEvent = (reason: string, extra?: Record<string, unknown>) => {
  try {
    const accessToken = localStorage.getItem(LOCAL_STORAGE.accessTokenKey);
    const refreshToken = localStorage.getItem(LOCAL_STORAGE.refreshTokenKey);

    let tokenRemaining: string | null = null;
    let tokenLifetime: string | null = null;

    if (accessToken) {
      try {
        const decoded: IDecoded = jwt_decode(accessToken);
        const now = Date.now() / 1000;
        if (decoded.exp) tokenRemaining = fmt(decoded.exp - now);
        const issuedAt = decoded.iat ?? decoded.nbf;
        if (decoded.exp && issuedAt) tokenLifetime = fmt(decoded.exp - issuedAt);
      } catch {
        tokenRemaining = "token inválido";
      }
    }

    const entry: ISessionLogEntry = {
      at: new Date().toISOString(),
      reason,
      path: window.location.pathname,
      hadAccessToken: Boolean(accessToken),
      hadRefreshToken: Boolean(refreshToken),
      tokenRemaining,
      tokenLifetime,
      extra,
    };

    const log = [...readSessionLog(), entry].slice(-MAX_ENTRIES);
    localStorage.setItem(LOG_KEY, JSON.stringify(log));
    console.log("[SESSION-LOG]", JSON.stringify(entry));
  } catch (error) {
    console.log("[SESSION-LOG] falha ao registrar evento:", error);
  }
};

export const printSessionLog = () => {
  const log = readSessionLog();
  console.log(`[SESSION-LOG] ${log.length} evento(s) registrado(s):`);
  log.forEach((e) => console.log("[SESSION-LOG]", JSON.stringify(e)));
  return log;
};

export default logSessionEvent;
